module.exports = __webpack_public_path__ + "static/assets/88c504e303387a131772b20b0070e28b.svg";